import * as React from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"
import './header.scss';
import { UrlService } from "../../core/services/UrlService";
import { construct } from "./dropdown/construct";

import HeaderConfig from '../../configs/header';
import { useCMS } from "../../cms/CMSDataProvider";

const Brand = () => {
    return (
        <Link className="nav-bar-component_brand-icon" to="https://finddoc.com">
            <img
                src={UrlService.getImageUrl('logo.png')}
                srcSet={`${UrlService.getImageUrl('logo.png')} 1x, ${UrlService.getImageUrl('logo@2x.png')} 2x, ${UrlService.getImageUrl('logo@3x.png')} 3x`}
                alt="FindDoc"
            ></img>
        </Link>
    );
};



const Header = () => {
    const data = useCMS();
    const config = HeaderConfig(data);
    return (
        <header>
            <>
                { construct(config.desktop, config.mobile) }
            </>
        </header>
    );
}

Header.propTypes = {
    siteTitle: PropTypes.string,
}

Header.defaultProps = {
    siteTitle: ``,
}

export default Header;
